import React from 'react';
import { ProductsCarouselItemProps } from '../../../products/components/products-carousel/types';
import { Product } from '../product';
import { productCardStyles } from 'features/products/components/products-carousel/styles';

type SponsoredProductsCarouselItemProps = ProductsCarouselItemProps & {
  isBrandShelf?: boolean;
  isSponsored?: boolean;
  isSimplifiedVariant?: boolean;
};

export const SponsoredProductsCarouselItem: React.FC<SponsoredProductsCarouselItemProps> = ({
  isBrandShelf,
  className,
  index = 1,
  product,
  ratings = [],
  elementBlock,
  'data-qa': dataQA = 'products-carousel-item',
  'data-sl-product-slot': dataSlProductSlot = 0,
  isSimplifiedVariant,
  isSponsored,
}) => (
  <div
    className={className}
    data-sl-product-id={product.productId}
    data-sl-strategy-id="255"
    data-sl-product-slot={dataSlProductSlot}
    data-qa={dataQA}
  >
    <Product
      isBrandShelf={isBrandShelf}
      key={product.productId}
      productPosition={index}
      className={productCardStyles}
      type="large-card"
      product={product}
      ratings={ratings}
      elementBlock={elementBlock}
      inWidget
      isSimplifiedVariant={isSimplifiedVariant}
      isSponsored={isSponsored}
    />
  </div>
);
